module.exports = __webpack_public_path__ + "img/guaranteeIcon2.6c023d7b.png";